

























import { Component, Vue, Watch, Emit, Prop } from 'vue-property-decorator';
@Component
export default class VariableSelect extends Vue {
  private validate = require('../../CommonUtils/fixed/Validate'); // Validate
  private privateInvaildMessage: string = '';
  private rules: any;
  private privateTextColor: string = '';
  // クリアボタンの設定
  // private clearable: boolean = false;
  @Prop() private name!: string;
  @Prop() private value?: string;
  @Prop() private readonly?: string;
  @Prop() private disabled?: string;
  @Prop() private required?: string;
  @Prop() private options!: [];
  @Prop() private invaildMessage?: string;
  @Prop() private textColor?: string;
  @Emit('input')
  private updateValue(value: string) {
    return value;
  }
  private created() {
    // 確認画面表示のdefault文字色設定
    if (!this.textColor) {
      this.privateTextColor = 'black--text';
    } else {
      this.privateTextColor = this.textColor;
    }
    // this.clearable = !(this.readonly === 'readonly' || this.disabled === 'disabled');
    if (this.invaildMessage) {
      this.privateInvaildMessage = this.invaildMessage;
    }
    // validationルールの設定
    this.rules = [(value: string) => (this.isValidateRequired(value)) || '必須項目です。'];
  }
  // validationの設定
  private isValidateRequired(value: string) {
    return this.validate.isValidateRequired(value, this.required);
  }
}
